<script setup lang="ts">
import type { PrivacyPolicyProps } from "./PrivacyPolicyProps";
import Switch from "@/views/blocks/shared/section/forms/switch/Switch.vue";
import { handleHashNavigation } from "@/shared/utils/router/hashNavigation";
defineProps<PrivacyPolicyProps>();

const emit = defineEmits<{
    (e: "update:agreed", value: boolean): void;
}>();
</script>

<template>
    <div class="flex gap-x-4 items-center sm:col-span-2">
        <div class="flex h-6 items-center">
            <Switch
                :model-value="agreed"
                @update:model-value="emit('update:agreed', $event)"
                :accent-color="accentColor"
                >{{ text }}</Switch
            >
        </div>
        <label
            class="text-sm/6 text-gray-600 cursor-pointer"
            @click="emit('update:agreed', !agreed)"
        >
            {{ text }}
            {{ " " }}
            <a
                :href="href"
                class="link-item text-sm/6"
                :style="{ color: accentColor }"
                @click.stop
                @click="handleHashNavigation"
                target="_blank"
                rel="noopener noreferrer"
            >
                {{ linkText }}
            </a>
        </label>
    </div>
</template>

<style scoped>
a {
    border-bottom: 1px solid transparent;
}

a:hover {
    border-bottom: 1px solid v-bind("accentColor");
}

a:active {
    border-bottom: 1px solid color-mix(in srgb, v-bind("accentColor"), transparent);
}

a:focus-visible {
    outline: 1px dotted v-bind("accentColor");
    outline-offset: 2px;
}
</style>
